"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.IconButton = void 0;

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _react = _interopRequireWildcard3(require("react"));

var _customProps = require("../../../../utils/customProps");

var _IconButton = require("./components/IconButton/IconButton");

var Tooltip = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../components/PageGrid/atoms/Tooltip/Tooltip"));
  });
});
/**
* IconButton for more docs check out https://material-ui.com/api/icon-button/#iconbutton-api
*/

var IconButton = function IconButton(props) {
  if (props.tooltip.length > 0) {
    return /*#__PURE__*/_react.default.createElement(_react.Suspense, {
      fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
    }, /*#__PURE__*/_react.default.createElement(Tooltip, props.tooltip[0], /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, props)));
  }

  return /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, props);
};

exports.IconButton = IconButton;
var _default = IconButton;
exports.default = _default;
IconButton.propTypes = {
  /** Tooltip to wrap button in to display help text */
  tooltip: function tooltip(props, propName, componentName) {
    var components = ['Tooltip'];
    return (0, _customProps.validComponents)(props, propName, componentName, components, 1);
  }
};
IconButton.defaultProps = {
  tooltip: []
};